import styled from "styled-components"

const NavigationTabBackground = styled.span`
  background: rgba(0, 0, 0, 0.3);
  margin: 0;
  padding: 0 30px;
  list-style: none;
  display: flex;
  align-items: center;
  height: 194px;
  width: 194px;
  z-index: -1;
  border-radius: 97px;
  position: absolute;
  margin-left: -97px;
  left: 50%;
  bottom: 0;
`

export default NavigationTabBackground



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationTabBackground.js